var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubjectContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    opacity: 0,
    "data-name": "Rechteck 135450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-57.27 -273.43)",
    d: "m74.152 283.14 5.027-2.3-10.054-4.609-10.055 4.606 5.027 2.3-5.027 2.3 5.02 2.3-5.02 2.3 10.055 4.606 10.055-4.606-5.02-2.3 5.02-2.3zm-5.027-5.893 7.837 3.59-4.111 1.883-3.726 1.707-3.725-1.707-4.111-1.883zm-3.919 6.4 3.919 1.8 3.919-1.8 3.919 1.8-7.837 3.59-7.837-3.59zm11.756 6.395-7.837 3.59-7.837-3.591 3.911-1.791 3.926 1.8 3.926-1.8z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: ".8px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubjectContracts);
export default __webpack_public_path__ + "static/media/hubjectContracts.09438908e9f434e3b5b0db0ac34cd825.svg";
export { ForwardRef as ReactComponent };